import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=6c556890&scoped=true"
import script from "./Msg.vue?vue&type=script&lang=js"
export * from "./Msg.vue?vue&type=script&lang=js"
import style0 from "./Msg.vue?vue&type=style&index=0&id=6c556890&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c556890",
  null
  
)

export default component.exports